enum FieldVisibility {

  VIEWING = 'viewing',
  EDITING = 'editing',
  BOTH = 'both',
  
}

export default FieldVisibility;
